module.exports = __webpack_public_path__ + "img/hexagon-mobile.755c00ac.svg";